import { rootApi } from "../../api/rootApi";

export const eCatalogueApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteCatelogue: builder.mutation({
        query: (params) => {
          return {
              method: "DELETE",
              url: `/tenant/eCatalogue/delete/${params.catalogueId}`,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + params.token,
                slug: params.tenant_id,
              },
            };
        },
      }),
    fetchCatelogues: builder.mutation({
      query: (params) => {
        let url = `/tenant/eCatalogue/?limit=${params.limit}&&offset=${params.offset}`;
        if (params?.language) {
          url += `&&language=${encodeURIComponent(params.language)}`;
        }
        return {
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
      },
    }),
    fetchCatelogueByCatalogueId: builder.mutation({
      query: (params) => {
        return {
            method: "GET",
            url: `/tenant/eCatalogue/?id=${params.id}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
      },
    }),
    uploadECatalogue: builder.mutation({
      query: (params) => {
        return {
          method: "post",
          url: `/tenant/eCatalogue/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug : params.tenant_id,
          },
          body : params.data
        };
      },
    }),

    updateECatalogue: builder.mutation({
      query: (params) => {
        return {
          method: "put",
          url: `/tenant/eCatalogue/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug : params.tenant_id,
          },
          body : params.data
        };
      },
    }),

    eCatalogueSequenceUpdate: builder.mutation({
      query: (params) => {
        return {
          method: "PATCH",
          url: `/tenant/eCatalogue/sequence`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const { useFetchCatelogueByCatalogueIdMutation , useFetchCateloguesMutation , useUploadECatalogueMutation , useUpdateECatalogueMutation ,useDeleteCatelogueMutation , useECatalogueSequenceUpdateMutation } = eCatalogueApi;
